import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

function ExternalHandleSizes({ register }) {
    const { watch, setValue } = useFormContext();
    const externalHandleStyle = watch('external_handle_style');

    // Use useRef to track if this is the first render
    const isFirstRender = useRef(true);

    const options = {
        'Flat_Silver': ['1000', '1200', '1400', '1600', '1800'],
        'Flat_Black': ['1000', '1200', '1400', '1600', '1800'],
        'Curved_Black': ['1200'],
        'Curved_Silver': ['1200'],
        'Round_Black': ['1000', '1200', '1400', '1600', '1800'],
        'Round_Silver': ['1000', '1200', '1400', '1600', '1800'],
        'Square_Black': ['900', '1200', '1600'],
        'Square_Silver': ['900', '1200', '1600']
    };

    useEffect(() => {
        // Skip setting default on the first render
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        // Set the default value only when externalHandleStyle changes
        if (externalHandleStyle && options[externalHandleStyle]) {
            setValue('external_handle_length', options[externalHandleStyle][0]);
        }
    }, [externalHandleStyle, setValue]);

    return (
        <div className='flex flex-col gap-6 col-span-full'>
            <p className='text-primary'>Handle Size</p>
            <div className='grid grid-cols-2 lg:grid-cols-3 w-full gap-2'>
                {
                    options[externalHandleStyle]?.map((name, index) => (
                        <div key={index} className='group cursor-pointer'>
                            <div className='relative flex flex-col items-center border-2 border-gray-700 group-has-[:checked]:border-primary p-4'>
                                <input
                                    className='absolute inset-0 z-10 h-full w-full opacity-0 cursor-pointer'
                                    value={name}
                                    type="radio"
                                    {...register('external_handle_length')}
                                />
                                <span className='text-gray-700 group-has-[:checked]:text-primary text-sm'>{name}(mm)</span>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default ExternalHandleSizes;
